// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__2Wck-","notes":"Notes_notes__33ciD","note":"Notes_note__4l_f4","markdown":"Notes_markdown__3LXou"};